export default "__VITE_ASSET__C3W1XRby__"